var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._v(" © 2022 Corendon Airlines. All Rights Reserved. "),_c('br')])
}]

export { render, staticRenderFns }